export class Path {
   static combine(...paths: string[]): string {
      let path = '';
      for (const s of paths) {
         if (s && s.length > 0) {
            const d = decodeURIComponent(s);
            path += s[0] === '/' ? d : '/' + d;
         }
      }
      return path;
   }

   static getAppUrl(path?: string): string {
      const url = location.origin + document.querySelector('base').getAttribute('href');
      if (path) {
         if (path[0] === '/') {
            path = path.substr(1);
         }
         return url + path;
      }
      return url;
   }
}
